export default __webpack_public_path__ + "static/media/logo-dark.ae7dd39d.svg";